// The file types an upload may be — the same list as the server's
// FileUploader::EXTENSIONS (which the presign step uses too). The server is
// the real gate; pages check this list up front so a file the server would
// refuse is turned away at once with a clear message, never lost quietly
// after it looked uploaded (Issue 41870). test/uploaders/file_uploader_extensions_test.rb
// fails if the two lists ever drift apart.
export const UPLOAD_EXTENSIONS = ["jpg","jpeg","gif","png","dng","heic","heif","webp","tiff","bmp","doc","docx","pdf","xml","txt","csv","xls","xlsx","xlsm","zip","rar","dwg","pptx","ppt","msg","eml","mp4","mov","webm","insp","insv","m4a","aac","caf","wav","mp3"]

export function uploadExtension(name) {
  const parts = String(name || "").split(".")
  return parts.length > 1 ? parts.pop().toLowerCase() : ""
}

export function uploadAllowed(name) {
  return UPLOAD_EXTENSIONS.includes(uploadExtension(name))
}
